// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ru-2";
export var chatLink = "_ru-0";
export var chatText = "_ru-1";